import React from "react";
import { Button } from "../../components/ui";

// Same backend period values the page already used via the old <Select>,
// just re-labeled/re-skinned as pills.
export const TIME_WINDOW_OPTIONS = [
  { id: "week", label: "7 days" },
  { id: "last_month", label: "30 days" },
  { id: "last_three_month", label: "3 months" },
];

/**
 * TimeWindowPills — "7 days / 30 days / 3 months" segmented row.
 * Replaces the legacy time-window <Select> dropdown in Insights.
 *
 * @param {"week"|"last_month"|"last_three_month"} value
 * @param {(next: string) => void} onChange
 */
const TimeWindowPills = ({ value, onChange }) => (
  <div className="core-list-pills" role="group" aria-label="Time window">
    {TIME_WINDOW_OPTIONS.map((opt) => (
      <Button
        key={opt.id}
        type="button"
        variant="tab"
        size="md"
        active={value === opt.id}
        aria-pressed={value === opt.id}
        onClick={() => onChange(opt.id)}
      >
        {opt.label}
      </Button>
    ))}
  </div>
);

export default TimeWindowPills;
